// 引入QS，axios的数据有问题
// import qs from 'qs';
import { doDecode, doEncode } from '@/util/base64';
import { request, util } from '@tencent/ppd-base-libs';
import to from '@/business/to.js';
import * as dayjs from 'dayjs';
import { getTestID, getAbtestGroup, isInABTTime } from '@/business/large-banner-abtest';

function fixedShakeData(item) {
  if (item.act_name === '日日狂賞搖' && item.prize_name === 'HK$500現金券' && item.count == 14) {
    item.prize_name = 'HK$2,888電子現金券禮包';
    item.count = '1';
    item.type = '1';
    item.jump_url = 'https://hkwallet.moneydata.hk/cgi-bin/app/ewallet_bindcard/ewallet_coupon_index.cgi?page=coupon-list&useable_flag=1&ADTAG=Shock';
  };
  return item;
}

function filterRecord(record) {
  const List = [];
  const now = new Date().getTime();
  for (let i = 0, iLen = record.length; i < iLen; i++) {
    console.log(record[i].create_time);
    record[i] = fixedShakeData(record[i]);
    if (now - new Date(record[i].create_time.replace(/-/g, '/')).getTime() <= 3600 * 24 * 31 * 1000) {
      List.push(record[i]);
    }
  }
  return List;
}

function filterListRecord(record) {
  const List = [];
  for (let i = 0, iLen = record.length; i < iLen; i++) {
    record[i] = fixedShakeData(record[i]);
    if (new Date(record[i].create_time.replace(/-/g, '/')).getTime() >= new Date('2019-06-03 00:00:00'.replace(/-/g, '/')).getTime()) {
      List.push(record[i]);
    }
  }
  return List;
}

// 获取红点信息
export async function getCouponInfo(data) {
  const [err, res] = await to(request.post('/app/promotion/prom_qry_usercoup_cnt.cgi', data));
  if (err) {
    console.log(err);
    return {};
  }
  if (res) {
    return res;
  }
  return {};
}
// 获取红点信息
export async function getStampInfo(data) {
  const [err, res] = await to(request.post('/app/promotion/prom_qry_userstamp_cnt.cgi', data));
  if (err) {
    console.log(err);
    return {};
  }
  if (res) {
    return res;
  }
  return {};
}

// 获取用户印花信息
export async function getStampList(data) {
  const [err, res] = await to(request.post('/app/promotion/prom_qry_userstamp_list.cgi', data));
  if (err) {
    console.log(err);
    return [];
  }
  if (res) {
    return JSON.parse(doDecode(res.stampcard_list));
  }
  return [];
}

// 获取优惠信息
export async function getDiscountRecord(data) {
  const [err, res] = await to(request.post('/app/promotion/prom_qry_flow_list.cgi?noreport=1', data));
  if (err) {
    console.log(err);
    return [];
  }
  return filterListRecord(JSON.parse(doDecode(res.flow_list)));
}

// 获取优惠信息
export async function getHomeDiscountRecord(data) {
  const [err, res] = await to(request.post('/app/promotion/prom_qry_flow_list.cgi?noreport=1', data));
  if (err) {
    console.log(err);
    return [];
  }
  if (res) {
    return filterRecord(JSON.parse(doDecode(res.flow_list)));
  }
  return [];
}

// 用户点击表头时间
export async function clickRegister(data) {
  const [err, res] = await to(request.post('/app/promotion/prom_visit_record.cgi', data));
  if (err) {
    return err;
  }
  return res;
}

// let cvQueryData;

// 查询登记状态
// export async function govCouponQueryReginfo() {
//   const [err, res] = await to(request.get('https://prom.wechatpay.com.hk/app/promotion/gov_coupons/gov_coupon_registration_qry.cgi'));
//   if (err) {
//     return err;
//   }
//   cvQueryData = res;
//   return res;
// }

// let bannerCVConfig;

// 获取消费券配置
// export async function getBannerConfigCV() {
//   const [err, res] = await util.to(request.loadVtools('/config/discount_center_banner_cv_utf8.js?noreport=1'));
//   if (err) {
//     return err;
//   }
//   bannerCVConfig = res;
//   return res;
// }
function isInTime(startTime, endTime) {
  const now = new Date().getTime();
  const start = dayjs(startTime).toDate();
  const end = dayjs(endTime).toDate();
  // const start = new Date(startTime).getTime();
  // const end = new Date(endTime).getTime();
  return start <= now && now <= end;
}


/**
 * 处理巨幕banner abtest
 */
function handleLargeBannerABT(config) {
  // 不是数组返回，兼容配置为对象的情况
  if (!Array.isArray(config)) {
    return config;
  }
  let bannerObj;
  const abtestID = getTestID();
  // 过滤时间过期的巨幕配置
  config = config.filter(item => isInTime(`${item.large_start_time} 00:00:00`, `${item.large_end_time} 23:59:59`));
  const groupData = getAbtestGroup();
  if (abtestID && groupData) {
    config.some((item) => {
      const groupItem = groupData.find(groupItem => groupItem.group === item.abtestGroup);
      if (groupItem?.abtestID.includes(abtestID)) {
        bannerObj = item;
      }
      return bannerObj;
    });
  }
  if (isInABTTime() && !bannerObj) {
    return {};
  }
  if (!bannerObj) {
    [bannerObj] = config;
  }
  return bannerObj || {};
}

// 用户点击表头时间
export function getBannerConfig() {
  // if (window.discount_center_banner_cv) {
  //   return window.discount_center_banner_cv[0];
  // }
  let config = window.discount_center_banner || {};

  config = handleLargeBannerABT(config);

  // const regInfo = cvQueryData;

  // let hasRegBanner; let noRegBanner;

  // const bannerCv = bannerCVConfig;

  // let isHasRegCv = false;

  // if (regInfo && regInfo.reg_state && !isNaN(regInfo.reg_state)) {
  //   // @ts-ignore
  //   isHasRegCv = regInfo && regInfo.reg_state && +regInfo.reg_state >= 2;
  // }

  // window.cvStatus = isHasRegCv ? '1' : '2'; // 1: 已登记 2：未登记
  // // 消费券的banner
  // if (bannerCv) {
  //   hasRegBanner = bannerCv.find(item => item.isHasLogic === '1' && isInTime(`${item.large_start_time} 00:00:00`, `${item.large_end_time} 23:59:59`));
  //   noRegBanner = bannerCv.find(item => item.isHasLogic === '2' && isInTime(`${item.large_start_time} 00:00:00`, `${item.large_end_time} 23:59:59`));
  //   if (isHasRegCv && hasRegBanner) { // 有时间就是已预约
  //     config = hasRegBanner;
  //   } else if (!isHasRegCv && noRegBanner) {
  //     config = noRegBanner;
  //   }
  // }

  return config;
}

// 获取banner列表配置
export function getActListConfig() {
  return window.discount_act_list || [];
}

/**
 * @description summer_prom_index.cgi 查询优惠券资格(查看首次有赏数据)
 *  {
 *    "retcode": "0",
 *    "retmsg": "OK",
 *    "active_user_flag": "0",
 *    "new_user_flag": "1",
 *    "sys_time": "2020-11-01 00:07:38",
 *    "Array": [{
 *        "task_id": "task_1",
 *        "task_state": "2"
 *    }, {
 *        "task_id": "task_2",
 *        "task_state": "2"
 *    }, {
 *        "task_id": "task_3",
 *        "task_state": "2"
 *    }, {
 *        "task_id": "task_4",
 *        "task_state": "2"
 *    }, {
 *        "task_id": "task_5",
 *        "task_state": "2"
 *    }]
 *  }
 */
export async function qrySummerProm() {
  const t = (new Date()).getTime();
  const [err, res] = await util.to(request.get(`//prom.wechatpay.com.hk/app/july/summer_prom_index.cgi?t=${t}`, {}));

  if (err) {
    console.log('summerProm', err);
    return Promise.reject(err);
  }
  return Promise.resolve({
    activeUserFlag: res.active_user_flag,
    newUserFlag: res.new_user_flag,
    sysTime: res.sys_time,
    array: res.Array,
  });
}

/**
 * @description 领取优惠券
 * 	{
 *    "retcode":"0",
 *    "retmsg":"OK",
 *    "exec_state":"0",
 *    "user_act":{
 *      "act_button":"View",
 *      "act_desc":"任務狂人_任務1【簽到】",
 *      "act_listid":"20200810778010001",
 *      "act_logo":"https://st.moneydata.hk/res/mojo_static/fca1b23b1a0a9d83060e869c4d2e1415.png",
 *      "act_name":"任務狂人_任務1【簽到】",
 *      "act_time":"2020-11-02 10:02:14",
 *      "act_type":"3",
 *      "amt":"1",
 *      "prize_url":"https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml?page=weeklytasks",
 *      "rank_desc":"「任務狂人」印花",
 *      "ref_amt":"0",
 *      "reverse_time":"",
 *      "spidpay_listid":"4ed319df43c23c1565bce7f0ee730cac",
 *      "state":"1",
 *      "user_id":"o5PXlsgdEWkWZjw2dWVs9RLkckOU"
 *    }
 * }
 */
export async function receiveCoupon(opts) {
  const t = (new Date()).getTime();
  return request.get(`//prom.wechatpay.com.hk/app/promotion/prom_exec_act.cgi?t=${t}`, {
    params: opts,
  });
}

/**
 * @description 查询普通券
 * {
 *  "retcode":"0",
 *  "retmsg":"OK",
 *  "coupon_list":"W3siYWN0X2xpc3RpZCI6Ikg3djhwamVQYUpDR3NxamIzVUdJc2wxbFpXZTFhKzJQZHd6MkkyMHJTVlU9IiwiY291cG9uX2Rlc2MiOiLlhajln47ni4Los54iLCJjb3Vwb25faWQiOiI2YlJJQXVFaUs2UytBckl2TElaZ294dzI2a0hjWVBmajd4ZGdmWUl2N3RVPSIsImNvdXBvbl9uYW1lIjoi6L+O5paw54uC6LOe5Yi4IiwiY291cG9uX3JhbmdlIjoi6aaZ5riv5pSv5oyBV2VDaGF0IFBheSBIS+eahOWVhuaItuWPiuacjeWLmSIsImRpc2NvdW50IjoyMDAwLCJkaXNwYXRjaF9jb3VudCI6MTY4NTMyLCJleHBpcmVfZGF5IjoxNCwiZXhwaXJlX3RpbWUiOiIyMDIwLTExLTAzIDIzOjU5OjU5IiwicmVjZWl2ZV90aW1lIjoiMjAyMC0xMC0yMSAwOTo1OTowMyIsInJlY2l2ZWRfbnVtIjowLCJyZXF1aXJlZF9udW0iOjMwMDAsInN0YXRlIjoxLCJ0b3RhbF9jb3VudCI6MTczNTAwLCJ0b3RhbF9udW0iOjAsInVzZXJfY291cG9uaWQiOiIyMDIwMTAyMTYwMDU1Mjg0NTA5NTkwMzk4Mjg1In1dCg==",
 *  "sys_time":"2020-11-02 09:49:04"
 * }
 * @external coupon_list为base64加密，
 */
export async function qryCouponInfo(opts) {
  const t = (new Date()).getTime();
  const url = `//prom.wechatpay.com.hk/app/promotion/prom_qry_simplecoup_info.cgi?t=${t}`;

  const [err, res] = await util.to(request.get(url, {
    params: opts,
  }));
  if (err) {
    console.log('couponInfo', err);
    Promise.reject(err);
  } else {  // retcode=0
    // const test = doEncode(JSON.stringify([{
    //   act_listid: "H7v8pjePaJCGsqjb3UGIsl1lZWe1a+2Pdwz2I20rSVU=",
    //   coupon_desc: "全城狂賞",
    //   coupon_id: "6bRIAuEiK6S+ArIvLIZgoxw26kHcYPfj7xdgfYIv7tU=",
    //   coupon_name: "迎新狂賞券",
    //   coupon_range: "香港支持WeChat Pay HK的商戶及服務",
    //   discount: 2000,
    //   dispatch_count: 168841,
    //   expire_day: 14,
    //   expire_time: "2020-11-01 23:59:59",
    //   receive_time: "2020-10-21 09:59:03",
    //   recived_num: 0,
    //   required_num: 3000,
    //   state: 1,
    //   sysTime: "2020-11-02 15:18:29",
    //   total_count: 173500,
    //   total_num: 0,
    //   user_couponid: "2020102160055284509590398285"
    // }]));
    // console.log('test', test);
    // 解码res.coupon_list后再返回
    const couponList = res.coupon_list ? JSON.parse(doDecode(res.coupon_list)) : [{}];
    return Promise.resolve({
      ...couponList[0],
      sysTime: res.sys_time,
    });
  }
}

/**
 * 远程拉取线上推荐配置
 */
export async function loadRecommendAndHotshopConf() {
  const url = '//st.moneydata.hk/res/g/js/mod/vtools/discount_center/recommendAndHotshop_utf8.json';
  const [err, res] = await util.to(request.loadVtools(url, 15 * 60 * 1000));

  if (err) {
    // 静默处理
    console.log('loadRecommendAndHotshopConf', err);
    return {};
  }

  return res;
}
